@let $assessable = contextService.$assessable | async;

@if (store.isEditPanel()) {
	<div class="mat-h2">
		{{ groupsHeaderLocalizationKey | translate }}
	</div>
}

@if ($assessable && contextService.form) {
	<mat-accordion
		cdkDropList
		[cdkDropListData]="contextService.form.controls.assessableGroups"
		[multi]="true"
		(cdkDropListDropped)="contextService.dropGroupPanel($event)"
		#previewHolder
		[formGroup]="contextService.form"
	>
		@for (group of $assessable.assessableGroups; track group.groupId) {
			<sim-assessable-group
				[groupIndex]="$index"
				[group]="group"
				[scoreTemplate]="scoreTemplate"
				[addItemToGroupLocalizationKey]="addItemToGroupLocalizationKey"
				[itemTemplateRef]="itemTemplateRef()"
				[previewElement]="previewHolder"
			/>
		}
	</mat-accordion>
}

@if ($assessable?.assessableGroups?.length > 0) {
	<div class="accordionSpacer"></div>
}

@if (store.isEditPanel() && type === AssessablePanelType.Checklist && $assessable?.ungroupedItems?.length > 0) {
	<div class="textNonGroupedChecklistEntries mat-h2">
		<span class="titleIndex">{{ $assessable.assessableGroups.length + 1 }}.</span>{{ nonGroupedItemsHeaderLocalizationKey | translate }}
	</div>
}

<!-- UNGROUPED ITEMS -->
@if ($assessable && type === AssessablePanelType.Checklist) {
	<div class="holderForNonGroupedChecklists">
		<mat-accordion
			cdkDropList
			[id]="UNGROUPED_ITEMS_GROUP_ID"
			[cdkDropListData]="contextService.form.controls.ungroupedItems"
			(cdkDropListDropped)="contextService.dropUngroupedItem($event)"
		>
			@for (item of $assessable.ungroupedItems; track item.assessableItemId) {
				<div cdkDrag class="assessableItemPanel" [cdkDragDisabled]="!store.isEditPanel() || !contextService.form.valid">
					<ng-template #dragHandle>
						@if (store.isEditPanel()) {
							<button
								[disabled]="!contextService.form.valid"
								[disableRipple]="true"
								appStopPropagation
								cdkDragHandle
								mat-icon-button
								[class.dragHandle]="contextService.form.valid"
								color="accent"
								[matTooltip]="T.ASSESSABLE_ITEM_DRAG_HINT | translate"
								matTooltipClass="accent"
							>
								<mat-icon fontSet="fa" fontIcon="fa-arrows" inline />
							</button>
						}
					</ng-template>
					<ng-container
						*ngTemplateOutlet="
							itemTemplateRef();
							context: {
								$implicit: {
									dragHandle: dragHandle,
									item: item,
									groupItems: $assessable.ungroupedItems,
									groupId: null,
									index: $index,
									groupIndex: null,
									length: $assessable.ungroupedItems.length,
								},
							}
						"
					/>
				</div>
			}

			@if ($assessable.ungroupedItems?.length === 0) {
				<div class="noUngroupedChecklistEntries"></div>
			}
		</mat-accordion>
	</div>
}
